// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as MenuActions from "../../resources/navigation/MenuActions.res.js";
import * as CatalogRoutes from "../../app/Catalog/CatalogRoutes.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogVariantMutations from "./CatalogVariantMutations.res.js";
import * as CatalogVariantArchiveModal from "./CatalogVariantArchiveModal.res.js";

function CatalogTableActions(props) {
  let status = props.status;
  let id = props.id;
  let cku = props.cku;
  let scope = Auth.useScope();
  let activeShop = Auth.useActiveShop();
  let match = Navigation.useUrl();
  let pathname = match.pathname;
  let match$1 = React.useState(() => false);
  let setArchiveModalOpened = match$1[1];
  let unarchiveVariant = CatalogVariantMutations.useUnarchive(id);
  let activateVariant = CatalogVariantMutations.useActivate(id);
  let deactivateVariant = CatalogVariantMutations.useDeactivate(id);
  let fromCatalogListPage = pathname === CatalogRoutes.baseRoute;
  let disabledKeysMenuActions = fromCatalogListPage && Stdlib_Option.isNone(activeShop) ? [
      "archive",
      "unarchive",
      "activate",
      "deactivate"
    ] : [];
  let tooltipTextMenuActionsItem = fromCatalogListPage && Stdlib_Option.isNone(activeShop) ? I18n.t("Please select a shop beforehand.") : undefined;
  let tmp;
  tmp = scope.TAG === "Organisation" ? JsxRuntime.jsx(MenuActions.Item.make, {
      title: I18n.t("Duplicate"),
      href: CatalogRoutes.variantDuplicationRoute(cku),
      icon: "duplicate_v2"
    }) : null;
  let tmp$1;
  let exit = 0;
  if (typeof status === "object") {
    tmp$1 = JsxRuntime.jsx(MenuActions.Item.make, {
      title: I18n.t("Unarchive"),
      icon: "archive",
      tooltipText: tooltipTextMenuActionsItem,
      onAction: () => {
        unarchiveVariant();
      }
    }, "unarchive");
  } else {
    exit = 1;
  }
  if (exit === 1) {
    let tmp$2;
    if (status !== undefined) {
      let exit$1 = 0;
      if (typeof status !== "object") {
        switch (status) {
          case "Inactive" :
            tmp$2 = JsxRuntime.jsx(MenuActions.Item.make, {
              title: I18n.t("Mark as on sale"),
              icon: "product_ok",
              tooltipText: tooltipTextMenuActionsItem,
              onAction: () => {
                activateVariant();
              }
            }, "activate");
            break;
          case "Active" :
          case "Unarchived" :
            exit$1 = 2;
            break;
        }
      } else {
        tmp$2 = null;
      }
      if (exit$1 === 2) {
        tmp$2 = JsxRuntime.jsx(MenuActions.Item.make, {
          title: I18n.t("Remove from sale"),
          icon: "product_nok",
          tooltipText: tooltipTextMenuActionsItem,
          onAction: () => {
            deactivateVariant();
          }
        }, "deactivate");
      }
    } else {
      tmp$2 = null;
    }
    tmp$1 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        tmp$2,
        JsxRuntime.jsx(MenuActions.Item.make, {
          title: I18n.t("Archive"),
          tone: "danger",
          icon: "archive",
          tooltipText: tooltipTextMenuActionsItem,
          onAction: () => setArchiveModalOpened(param => true)
        }, "archive")
      ]
    });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(Tooltip.make, {
        children: JsxRuntime.jsxs(MenuActions.make, {
          children: [
            pathname.endsWith("/catalog") ? JsxRuntime.jsx(MenuActions.Section.make, {
                children: JsxRuntime.jsx(MenuActions.Item.make, {
                  title: I18n.t("New variant"),
                  href: CatalogRoutes.createRedirectRoute(cku),
                  tone: "brand",
                  icon: "variant_add"
                })
              }) : null,
            JsxRuntime.jsxs(MenuActions.Section.make, {
              children: [
                JsxRuntime.jsx(MenuActions.Item.make, {
                  title: I18n.t("See"),
                  href: CatalogRoutes.variantRoute(cku),
                  icon: "see_ok"
                }),
                JsxRuntime.jsx(MenuActions.Item.make, {
                  title: I18n.t("Edit"),
                  href: CatalogRoutes.variantEditRoute(cku),
                  icon: "edit"
                }),
                tmp,
                pathname.includes("/product") ? null : JsxRuntime.jsx(MenuActions.Item.make, {
                    title: I18n.t("See bound product"),
                    href: CatalogRoutes.productRedirectRoute(cku),
                    icon: "variant_see"
                  })
              ]
            }),
            JsxRuntime.jsx(MenuActions.Section.make, {
              children: tmp$1
            })
          ],
          trigger: {
            TAG: "Compact",
            icon: "more_v2",
            variant: "subtle",
            size: "small",
            bold: true
          },
          disabledKeys: disabledKeysMenuActions
        }),
        arrowed: false,
        placement: "top",
        content: JsxRuntime.jsx(Tooltip.Span.make, {
          text: I18n.t("More actions...")
        }),
        closeDelay: 0
      }),
      JsxRuntime.jsx(CatalogVariantArchiveModal.make, {
        id: id,
        opened: match$1[0],
        onRequestClose: () => setArchiveModalOpened(param => false)
      })
    ]
  });
}

let make = React.memo(CatalogTableActions);

export {
  make,
}
/* make Not a pure module */
